import React from 'react'
import UserCard from './UserCard'
import styles from './user-list.module.scss'

interface User {
    id: string
    name: string
    username?: string
    bio?: string
    description?: string
    md5_email?: string
    path?: string
    is_followed_by_current_user?: boolean
}

interface UserListProps {
    users: User[]
    onFollowToggle?: (userId: string, isFollowing: boolean) => void
    onUserClick?: () => void
}

export default function UserList({ users, onFollowToggle, onUserClick }: UserListProps) {
    return (
        <div className={styles.userList}>
            {users.map(user => (
                <UserCard
                    key={user.id}
                    user={user}
                    onFollowToggle={onFollowToggle}
                    onUserClick={onUserClick}
                />
            ))}
            {users.length === 0 && <div className={styles.emptyState}>No users to display</div>}
        </div>
    )
}
